import {ChangeDetectionStrategy, Component, Inject, OnInit, Optional} from '@angular/core';

import { DynamicModule, EntityView, FieldOkResultConverter } from "@softline/dynamic";
import {addDays, DateService, endOfWeek, startOfMonth, startOfWeek, Store} from '@softline/core';
import {Router} from '@angular/router';
import {BackNavigable, BackNavigationService, SOFTLINE_FEATURE_TITLE, TitleStore} from '@softline/application';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {WorkNote} from '../../data/work-note';
import {WorkNoteQuery} from '../../data/work-note-query';
import {ArbeitsscheinConfig, SOFTLINE_CONFIG_ARBEITSSCHEIN} from '../../arbeitsschein.config';

import { DateInputComponent } from '@softline/ui-core/date-input';
import { TranslatePipe } from '@softline/ui-core';
@Component({
    selector: 'soft-work-note-query-page',
    imports: [ReactiveFormsModule, DynamicModule,
    DateInputComponent,
    TranslatePipe],
    templateUrl: './work-note-query-page.component.html',
    styleUrls: ['./work-note-query-page.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WorkNoteQueryPageComponent implements OnInit, BackNavigable {

  objectValueConverter = new FieldOkResultConverter({ objekt: 'number', bezeichnung: 'name' })

  readonly currentWeekQuery: WorkNoteQuery = {
    from: startOfWeek(this.dateService.now()),
    to: this.dateService.now() };

  readonly lastWeekQuery: WorkNoteQuery = {
    from: startOfWeek(addDays(this.dateService.now(), -7)),
    to: endOfWeek(addDays(this.dateService.now(), -7)) };

  readonly currentMonthQuery: WorkNoteQuery = {
    from: startOfMonth(this.dateService.now()),
    to: this.dateService.now() };

  readonly form = new FormGroup({
    from: new FormControl<string | null>(null, Validators.required),
    to: new FormControl<string | null>(null, Validators.required),
    object: new FormControl<WorkNote['kopfau']['objekt'] | null>(null)
  })

  constructor(
    private store: Store,
    protected router: Router,
    private dateService: DateService,
    private backNavigationService: BackNavigationService,
    @Optional() @Inject(SOFTLINE_CONFIG_ARBEITSSCHEIN) readonly config: ArbeitsscheinConfig
  ) {}

  ngOnInit(): void {
    this.backNavigationService.set(this);
    this.store.commit(
      SOFTLINE_FEATURE_TITLE,
      TitleStore.mutations.setTitle,
      '#WORK_NOTE.QUERY.QUERY.TITLE'
    );
  }

  ngOnDestroy(): void {
    this.backNavigationService.set(undefined);
    this.store.commit(
      SOFTLINE_FEATURE_TITLE,
      TitleStore.mutations.setTitle,
      ''
    );
  }

  async navigateBack(): Promise<void> {
    await this.router.navigate(['/arbeitsschein']);
  }

  async onSubmit(query: typeof this.form.value) {
    let { from, to, object } = query;
    from = ((from?.length || 0) > 0) ? from?.substring(0, 10) : undefined;
    to = ((to?.length || 0) > 0) ? to?.substring(0, 10) : undefined;
    const objectId = (object && object?.id) ? object.id : undefined;
    const queryParams = objectId ? { objectId, from, to } : { from, to };
    await this.router.navigate(['/arbeitsschein'], { queryParams });
  }

  async onShowMuster() {
    const queryParams = { kzMuster: true }
    await this.router.navigate(['/arbeitsschein'], { queryParams });
  }
}
